import type { RefObject } from "react";

const ICON_HEIGHT = 25;
const MIN_BOTTOM_MARGIN = 10;
const MIN_FRAME_SIZE = 210;
const MAX_HEIGHT = 620;
const MIN_HEIGHT = 290;
const MIN_WINDOW_WIDTH = 960;

export const calculatFrameHeight = (ref: RefObject<HTMLDivElement | null>) => {
  const { innerHeight = 1000, innerWidth = 1000 } = window;

  if (innerWidth < MIN_WINDOW_WIDTH) {
    return {};
  }

  const { top: miniCartPosition = 0 } = ref?.current?.getBoundingClientRect() ?? {};
  const maxHeight = Math.floor(innerHeight - miniCartPosition - ICON_HEIGHT - MIN_BOTTOM_MARGIN);
  const minHeight = Math.min(maxHeight, MIN_HEIGHT);

  return {
    maxHeight: Math.min(maxHeight, MAX_HEIGHT),
    minHeight: Math.max(minHeight, MIN_FRAME_SIZE),
  };
};
